import React from "react";
import { Image } from "react-bootstrap";
import AdSpace from "../../images/Frame 1948765911.png";

const RightSection = () => {
  const goToWebsite = () => {
    window.open("http://ez1020.com/", "_blank");
  };
  return (
    <div className="d-flex flex-column align-items-end justify-content-between h-auto adspace-sec">
      <Image src={AdSpace} alt={AdSpace} onClick={goToWebsite} style={{ cursor: "pointer" }} className="position-relative" />
      <span className="position-absolute top-auto right-auto left-auto"></span>
    </div>
  );
};

export default RightSection;